import Alert from '@mui/material/Alert';
import { TaskAssignment } from 'modules/work-implementation/task-management/analyst/sections';
import { WORK_PROGRESS_STEP_KEYS } from '../constants';

const STEP_COMPONENT_MAP = {
  [WORK_PROGRESS_STEP_KEYS.ASSIGN]: TaskAssignment,
  [WORK_PROGRESS_STEP_KEYS.IN_PROGRESS]: ComingSoonAlert,
  [WORK_PROGRESS_STEP_KEYS.APPROVAL]: ComingSoonAlert,
};

function ComingSoonAlert() {
  return <Alert severity='info'>Coming Soon</Alert>;
}

function NotFoundAlert() {
  return <Alert severity='error'>Not Found</Alert>;
}

/**
 * WorkProgressContent component
 * @param {Object} props
 * @param {Object} props.data
 * @param {Array} props.taskList
 * @param {Array} props.steps
 * @param {number} props.activeStep
 * @param {Function} props.refresh
 * @returns {JSX.Element}
 */
export default function WorkProgressContent({ data, taskList, steps, activeStep, refresh }) {
  const stepKey = steps[activeStep]?.key;
  const StepComponent = STEP_COMPONENT_MAP[stepKey] || NotFoundAlert;

  return (
    <StepComponent
      data={{
        taskConfig: data?.taskConfig,
        projectData: data?.commonDetails,
      }}
      assignedTasks={taskList}
      refresh={refresh}
    />
  );
}
